import { createPortal } from 'preact/compat';
import { ModalEmpty } from './ModalEmpty.tsx';
import type { ComponentChildren, Ref } from 'preact';
import noop from 'lodash/noop';

export type Props = {
	onClose?: () => void;
	onClickAway?: () => void;
	children?: ComponentChildren;
	className?: string;
	modalLayer?: 2;
	isMobileFullscreen?: boolean;
	forwardedRef?: Ref<HTMLDivElement>;
};

export function Modal({
	children,
	onClickAway = noop,
	onClose = noop,
	className,
	modalLayer,
	isMobileFullscreen,
	forwardedRef,
}: Props) {
	return createPortal(
		<ModalEmpty
			onClose={onClose}
			onClickAway={onClickAway}
			className={className}
			isMobileFullscreen={isMobileFullscreen}
			forwardedRef={forwardedRef}
		>
			{children}
		</ModalEmpty>,
		globalThis.document.getElementById(`modal-layer${modalLayer ? modalLayer : ''}`)!,
	);
}
